import config from '@/config'

export default {
  computed: {

    brandKey () {
      return config.app.BRAND
    }
  },

  methods: {
  },

  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Branding.js